import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Benefits|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Benefit,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogCredentialsBenefits';
export type SPCatalogCredentialsBenefitsLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ContentStatusInactive`
	| `${LocNameStart}ContentStatusActive`
	| `${LocNameStart}LabelFilterByStatus`
	| `${LocNameStart}LabelFilterByGroup`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelGroup`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelNameAbbr`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelGrantType`
	| `${LocNameStart}LabelGrantStartDate`
	| `${LocNameStart}LabelGrantEndDate`;

export const spCatalogCredentialsBenefitsLocs: LocDefs<SPCatalogCredentialsBenefitsLocNames> = {
	SPCatalogCredentialsBenefitsTitleTab: {
		defaultValue: 'Credential Benefits',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.Title.TabTitle',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsTitleSection: {
		defaultValue: 'Credential Benefits',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.Title.SectionTitle',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsContentStatusActive: {
		defaultValue: 'Active',
		description: 'Active benefit catalog status',
		displayPath: `${pathStart}Active Status`,
		displayType: 'Content',
		legacyName: 'Benefit/Catalogs.Benefits.Status.System.Active',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsContentStatusInactive: {
		defaultValue: 'Inactive',
		description: 'Inactive benefit catalog status',
		displayPath: `${pathStart}Inactive Status`,
		displayType: 'Content',
		legacyName: 'Benefit/Catalogs.Benefits.Status.System.Inactive',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelFilterByStatus: {
		defaultValue: 'Filter by Status',
		description: 'Label for: Filter by Status.',
		displayPath: `${pathStart}Filter by Status`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.FieldLabel.StatusFilter',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelFilterByGroup: {
		defaultValue: 'Filter by Group',
		description: 'Label for: Filter by Group.',
		displayPath: `${pathStart}Filter by Group`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.FieldLabel.GroupFilter',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelStatus: {
		defaultValue: 'Status',
		description: 'Label for: Status.',
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.ColumnHeading.Status',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelGroup: {
		defaultValue: 'Group',
		description: 'Label for: Group.',
		displayPath: `${pathStart}Group`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.ColumnHeading.Group',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelName: {
		defaultValue: 'Name',
		description: 'Label for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelNameAbbr: {
		defaultValue: 'Name Abbreviation',
		description: 'Label for: Name Abbreviation.',
		displayPath: `${pathStart}Name Abbreviation`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.ColumnHeading.NameAbbr',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelType: {
		defaultValue: 'Type',
		description: 'Label for: Type.',
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.ColumnHeading.Type',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelGrantType: {
		defaultValue: 'Grant Type',
		description: 'Label for: Grant Type.',
		displayPath: `${pathStart}Grant Type`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.ColumnHeading.GrantType',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelGrantStartDate: {
		defaultValue: 'Start Date',
		description: 'Label for: Start Date.',
		displayPath: `${pathStart}Start Date`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.ColumnHeading.StartDate',
		...sharedProperties,
	},
	SPCatalogCredentialsBenefitsLabelGrantEndDate: {
		defaultValue: 'End Date',
		description: 'Label for: End Date.',
		displayPath: `${pathStart}End Date`,
		displayType: 'Label',
		legacyName: 'Benefit/Catalogs.Credentials.Benefits.ColumnHeading.EndDate',
		...sharedProperties,
	},
};

export type SPCatalogCredentialsBenefitsLocType = LocMap<SPCatalogCredentialsBenefitsLocNames>;
